import { render, staticRenderFns } from "./WebatySidebarNavItem.vue?vue&type=template&id=3caff581&"
import script from "./WebatySidebarNavItem.vue?vue&type=script&lang=js&"
export * from "./WebatySidebarNavItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports